import { render } from "./CheckView.vue?vue&type=template&id=131bcbd8&scoped=true"
import script from "./CheckView.vue?vue&type=script&lang=js"
export * from "./CheckView.vue?vue&type=script&lang=js"

import "./CheckView.vue?vue&type=style&index=0&id=131bcbd8&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131bcbd8"]])

export default __exports__